import { Button, useDialog, type ButtonConfig } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { NewComponentRequestDialog } from '@components/NewComponentCreateRequestTrigger/components/NewComponentsRequestDialog/NewComponentRequestDialog';
import SearchComponentsDialog, {
    type SearchComponentsDialogProps,
} from '@components/NewComponentCreateRequestTrigger/components/SearchComponentsDialog/SearchComponentsDialog';

interface NewComponentCreateRequestTriggerProps {
    searchComponentsDialogProps?: SearchComponentsDialogProps;
}

export function NewComponentCreateRequestTrigger({
    searchComponentsDialogProps,
}: NewComponentCreateRequestTriggerProps): ReactNode {
    const { form } = useDialog();

    function openNewComponentRequestModal(): void {
        form({
            title: 'Request new component',
            content: (
                <NewComponentRequestDialog
                    searchComponentsDialogProps={searchComponentsDialogProps}
                />
            ),
            buttons: {
                submitLabel: 'Submit request',
                closeButton: getCloseButton(),
            },
        });
    }

    function getCloseButton(): ButtonConfig | undefined {
        if (!searchComponentsDialogProps) {
            return undefined;
        }

        return {
            label: 'Go back',
            overrideDefault: true,
            callback: () => {
                form({
                    title: 'Search and select component',
                    content: (
                        <SearchComponentsDialog
                            {...searchComponentsDialogProps}
                        />
                    ),
                    buttons: {
                        submitLabel: 'Use selected component',
                    },
                });
            },
        };
    }

    return (
        <Button
            className="w-fit align-self-end"
            label="Request new component"
            severity="secondary"
            onClick={openNewComponentRequestModal}
        />
    );
}
